document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.newsletter-form');
  if (!form) return;
  const emailInput = form.querySelector('.newsletter-input');
  const messageDiv = form.querySelector('.newsletter-message');

  const showMessage = (msg, type = 'success') => {
    messageDiv.textContent = msg;
    messageDiv.classList.remove('newsletter-error', 'newsletter-success');
    if (type === 'error') {
      messageDiv.classList.add('newsletter-error');
    } else {
      messageDiv.classList.add('newsletter-success');
    }
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = emailInput.value.trim();
    if (!email) {
      showMessage('Podaj adres e-mail.', 'error');
      emailInput.focus();
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showMessage('Wpisz poprawny adres e-mail.', 'error');
        emailInput.focus();
      return;
    }
    const submitBtn = form.querySelector('.newsletter-submit');
    submitBtn.disabled = true;
    showMessage('Wysyłanie...');
    try {
      const endpoint = 'https://assets.mailerlite.com/jsonp/1685885/forms/161820614010603019/subscribe';
      const formData = new FormData();
      formData.append('fields[email]', email);
      const response = await fetch(endpoint, {
        method: 'POST',
        body: formData,
      });
      if (response.ok) {
        showMessage('Dziękujemy za zapis! Sprawdź swoją skrzynkę e-mail.');
        form.reset();
      } else {
        showMessage('Wystąpił błąd podczas zapisu. Spróbuj ponownie później.', 'error');
      }
    } catch (err) {
      showMessage('Nie udało się połączyć z serwerem. Spróbuj ponownie później.', 'error');
    } finally {
      submitBtn.disabled = false;
    }
  });
});
